const RawHtmlVideo = ({ src, backupSrc }) => {
  const html = `
    <video autoplay muted loop playsInline>
      ${src ? `<source src="${src}" />` : ''}
      ${backupSrc ? `<source src="${backupSrc}" />` : ''}
    </video>`;

  return <span dangerouslySetInnerHTML={{ __html: html }} />;
}

export default RawHtmlVideo;